import React, { useEffect, useState } from "react";
import Nav from "@/components/Nav";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Copy, Users, Gift } from "lucide-react";
import ReferralLeaderboard from "@/components/ReferralLeaderboard";
import ReferralBadge from "@/components/ReferralBadge";

export default function Referrals() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/referrals/me").then((r) => setData(r.data)).catch(()=>{}); }, []);

  if (!data) return <div className="min-h-screen bg-[#FAFBFD]"><Nav /><div className="p-12 text-center text-slate-500">Loading…</div></div>;

  const link = `${window.location.origin}/auth?ref=${data.referral_code}`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success("Referral link copied!");
    } catch {
      try {
        const ta = document.createElement("textarea");
        ta.value = link;
        ta.style.position = "fixed"; ta.style.left = "-9999px";
        document.body.appendChild(ta); ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        toast.success("Referral link copied!");
      } catch {
        toast.error("Couldn't copy — long-press the link and copy manually.");
      }
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFBFD]">
      <Nav />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">Give $10, get $10</h1>
        <p className="text-slate-600 mt-2">Share Powerhouse Refunds. Your friend gets $10 off their first case. You get $10 credit when they pay.</p>

        <Card className="trust-card mt-8">
          <CardContent className="p-6 sm:p-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-emerald-100 text-emerald-700 grid place-items-center"><Gift className="w-5 h-5" /></div>
              <div>
                <p className="text-xs text-slate-500 uppercase tracking-widest">Your credit balance</p>
                <p className="text-3xl font-bold text-slate-900" data-testid="credit-balance">${data.credit_balance.toFixed(2)}</p>
              </div>
            </div>
            <div className="flex gap-2">
              <input value={link} readOnly className="flex-1 h-11 rounded-lg border border-slate-200 px-3 text-sm text-slate-700 bg-slate-50" data-testid="referral-link-input" />
              <Button onClick={copy} data-testid="referral-copy-link-button" className="rounded-full bg-[#1E3A8A] hover:bg-[#1E40AF] h-11 px-5">
                <Copy className="w-4 h-4 mr-2" /> Copy
              </Button>
            </div>
            <div className="flex items-center gap-2 mt-4 text-sm text-slate-600 flex-wrap">
              <Users className="w-4 h-4" />
              <span data-testid="referral-count">{data.referrals.length}</span> referrals ·
              <span data-testid="referral-credited-count">{data.referrals.filter(r=>r.status==="credited").length}</span> credited
              <ReferralBadge count={data.referrals.filter(r=>r.status==="credited").length} className="ml-1" />
            </div>
          </CardContent>
        </Card>

        <div className="mt-8">
          <ReferralLeaderboard />
        </div>
      </div>
    </div>
  );
}
